<template>
  <div class="account-row-data text-right">
    <span class="mx-2 card-grid-display font-weight-regular">{{ getCell }}</span>
  </div>
</template>

<script>
export default {
  components: {},
  name: "AccountDataColTemplate",
  props: {
    cell: {}, col: {}
  },
  computed: {
    getCell() {
      const cellValue = this.cell[this.data?.index]?.[this.col];
      
      if (cellValue == null || cellValue == undefined) return '-'

      if (cellValue == "NA") return '-'
      
      if (this.col === 'Previous Term Ratio') {
        return isNaN(cellValue) ? cellValue : `${parseFloat(cellValue.toFixed(2))}%`;
      }
      if (['Parent Basis Amount', 'Amount in Previous Term', 'Previous Term Difference', 'Consolidated Amount'].includes(this.col)) {
        let amount = typeof cellValue === 'string' ? Number(cellValue) : cellValue;
        return isNaN(amount) ? '-' : amount.toLocaleString();
      }
      return cellValue ?? '-';
    },
  }
};
</script>

<style scoped>
.v-tooltip {
  z-index: 1 !important;
}

.agenda-meeting-card .v-card__text {
  padding: 16px !important;
  color: var(--v-darkCharcoal-base) !important;
}

.card-grid-display {
  display: grid;
  grid-gap: 8px;
}
</style>